export const actions = {
  ADD: "ADD",
  DELETE: "DELETE",
  EDIT: "EDIT"
};
